import { LoaderCircle } from 'lucide-react';
import { cx } from '../../lib/util/cx';

/** Neutral loading affordance. The kit specifies no loading state; keep it quiet. */
export function Spinner({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <LoaderCircle
      size={size}
      strokeWidth={2}
      aria-hidden="true"
      className={cx('animate-spin text-brown motion-reduce:animate-none', className)}
    />
  );
}

export function LoadingState({ label = 'Loading…', fill = false }: { label?: string; fill?: boolean }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cx('flex items-center justify-center gap-3 py-10 text-sm text-muted', fill && 'h-full min-h-[50vh]')}
    >
      <Spinner />
      <span>{label}</span>
    </div>
  );
}
